import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import * as Sentry from '@sentry/react'
import { useFlagsStatus } from '@unleash/proxy-client-react'
import useOrbitFlag from 'hooks/useOrbitFlag'

import { JoyrideState } from './context/joyride/joyrideState'
import OrbitSession from './hooks/useCookies'
import useIdentity from './hooks/useIdentity'
import DemoEntryPt from './pages/DemoEntryPt'
import NotFound from './pages/NotFound'
import OrderFailure from './pages/Orders/OrderFailure'
import PaymentSuccess from './pages/Payment/PaymentSuccess'
import PermissionedRoute from './pages/PermissionedRoute'
import ClientApp from './router/ClientApp'
import DemoApp from './router/DemoApp'
import VendorApp from './router/VendorApp'
import { LogIn, OnboardingPage, OrderSuccess } from './pages'
// note: accessor for dexie db
/**
 * import { useLiveQuery } from 'dexie-react-hooks'
 * import { db } from './database/db'
 * const users = useLiveQuery(() => {
 * return db.user.toArray()
 * })
 * */

function App() {
  OrbitSession.set({ default: 'cookie' })

  const { identity } = useIdentity()

  const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes)

  const redirectToEngineFlag = useOrbitFlag('redirect-to-engine')
  const flags = useFlagsStatus()

  return !flags.flagsReady ? (
    <></>
  ) : (
    <>
      <JoyrideState>
        <SentryRoutes>
          <Route path='*' element={<NotFound />} />
          <Route path='/'>
            {redirectToEngineFlag && (
              <Route index element={<Navigate to='/login' />} />
            )}

            {['owner', 'admin'].includes(identity?.role || '') && (
              <Route index element={<Navigate to='/app' />} />
            )}

            {['opsowner', 'ops', 'opsviewer'].includes(
              identity?.role || ''
            ) && <Route index element={<Navigate to='/hq' />} />}

            {!redirectToEngineFlag && (
              <Route index element={<Navigate to='/login' />} />
            )}

            <Route path='login' element={<LogIn />} />
            <Route path='onboarding' element={<OnboardingPage />} />
            <Route path='order-success' element={<OrderSuccess />} />
            <Route path='payment-success' element={<PaymentSuccess />} />
            <Route path='order-failure' element={<OrderFailure />} />
            <Route path='marketing' element={<DemoEntryPt />} />
          </Route>

          <Route path='/demo/*' element={<DemoApp />} />
          <Route path='/demo/payment-success' element={<PaymentSuccess />} />

          <Route
            element={<PermissionedRoute allowedRoles={['owner', 'admin']} />}
          >
            <Route path='/app/*' element={<ClientApp />} />
          </Route>
          <Route
            element={
              <PermissionedRoute
                allowedRoles={['ops', 'opsowner', 'opsviewer']}
              />
            }
          >
            <Route path='/hq/*' element={<VendorApp />} />
          </Route>
        </SentryRoutes>
      </JoyrideState>
    </>
  )
}

export default App
